import React, { useState } from "react"
import useDisinfectionMeasures from "../../common/classifications/disinfection_measures"
import DisinfectionMeasureCategory from "./DisinfectionMeasureCategory.js"
import "./DisinfectionMeasureContainer.scss"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"

export const DisinfectionMeasureContainer = ({ listing, t }) => {
  const [isOpen, setIsOpen] = useState(false)

  const checkedCodes =
    (listing &&
      listing.property &&
      listing.property.disinfection_measure_codes) ||
    []
  const [{ categories }] = useDisinfectionMeasures()

  if (!checkedCodes.length) {
    return null
  }

  return (
    <section style={{ paddingBottom: 0 }}>
      <h2
        styleName={`measurement-section-heading ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen) }
      >
        {t("disinfection.title")}
      </h2>
      {isOpen &&
        <div styleName="measurement-wrapper">
          {Object.keys(categories).map((category) => {
            const measures = categories[category]
            const supportedMeasures = measures.filter(({ code }) =>
              checkedCodes.includes(code)
            )

            if (!supportedMeasures.length) {
              return null
            }

            return (
              <DisinfectionMeasureCategory
                key={category}
                heading={measures[0].category_name}
                supportedMeasures={supportedMeasures}
                icon={category}
              />
            )
          })}
        </div>
      }
    </section>
  )
}

export default compose(withNamespaces("listings"))(
  DisinfectionMeasureContainer
)
